<div class="modal-content" piqetAngularDraggable>
  <ng-container
    *ngrxLet="
      projectFacde.projectPackMaterialTransportScenarioList$ as projectPackMaterialTransportScenarioList
    "
  >
    <div class="organization-modal" id="org-top">
      <ng-container *ngrxLet="projectFacde.getConversionList$ as getConversionList">
        <div>
          <span class="bootstrap-dialog-title header-title">{{ modalLabel }}</span>
          <button
            type="button"
            aria-label="Close"
            class="closeModal pull-right"
            (click)="onClose()"
          >
            <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
          </button>
        </div>

        <div class="modal-body body-modal">
          <form [formGroup]="projectPackMaterialForm" (keydown.enter)="$event.preventDefault()">
            <div class="row" formGroupName="componentDetailForm">
              <div class="col-12">
                <label class="subTitleName">Component details</label>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group required" aria-required="true">
                    <div class="services-form">
                      <input
                        formControlName="componentName"
                        type="text"
                        maxlength="50"
                        placeholder="Component name"
                      />
                      <label>Component name</label>
                    </div>
                    <div
                      *ngIf="
                        submittedForComponent &&
                        projectPackMaterialForm.get('componentDetailForm')?.get('componentName')
                          ?.errors
                      "
                    >
                      <div
                        *ngIf="
                          projectPackMaterialForm.get('componentDetailForm')?.get('componentName')
                            ?.invalid ||
                          componentDetailForm.controls['componentName'].hasError('whitespace')
                        "
                        class="input-error"
                      >
                        The component name field is required
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group required">
                    <label
                      *ngIf="
                        projectPackMaterialForm.get('componentDetailForm')?.get('packagingLevels')
                          ?.value
                      "
                      class="sub-header-drpdown pb-2"
                      >Packaging level</label
                    >
                    <ng-select
                      [clearable]="true"
                      [clearOnBackspace]="false"
                      #package
                      [items]="packageLevel"
                      bindLabel="name"
                      [searchable]="false"
                      [searchFn]="commonInputSearch"
                      formControlName="packagingLevels"
                      placeholder="Packaging level *"
                      class="accordion-text addScroll"
                      [virtualScroll]="packageLevel.length > 5 ? true : false"
                    >
                      <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                        <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                          {{ item.name }}
                        </div>
                      </ng-template>
                    </ng-select>
                    <div
                      *ngIf="
                        submittedForComponent &&
                        projectPackMaterialForm.get('componentDetailForm')?.get('packagingLevels')
                          ?.errors
                      "
                    >
                      <div
                        *ngIf="
                          projectPackMaterialForm.get('componentDetailForm')?.get('packagingLevels')
                            ?.invalid
                        "
                        class="input-error"
                      >
                        Packaging level is required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group required">
                    <label
                      *ngIf="
                        projectPackMaterialForm.get('componentDetailForm')?.get('packagingLevels')
                          ?.value
                      "
                      class="placeholder-sub-header pb-2"
                      >Holder_text</label
                    >
                    <div class="ng-autocomplete">
                      <ng-autocomplete
                        #auto
                        [isLoading]="isLoading"
                        class="supplierdrpdown"
                        (selected)="selectedMaterial($event)"
                        (inputChanged)="onChangeSearchSupplier($event)"
                        [data]="searchSupplierList"
                        (inputCleared)="onClearSearchSupplier($event)"
                        [searchKeyword]="keyword"
                        historyIdentifier="supplier"
                        [itemTemplate]="itemTemplate"
                        formControlName="Supplier"
                        placeholder="Select supplier"
                      >
                      </ng-autocomplete>

                      <ng-template #itemTemplate let-item>
                        <div class="item"><span [innerHTML]="item.name"></span> &nbsp;</div>
                      </ng-template>

                      <ng-template #notFoundTemplate let-notFound>
                        <div [innerHTML]="notFound"></div>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div class="row" formGroupName="materialDetailForm">
              <div class="col-12">
                <label class="subTitleName">Material details</label>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="d-flex checkBoxAlienMent">
                    <!-- <div>
                                            <input type="checkbox" [ngModelOptions]="{standalone: true}"
                                                [(ngModel)]="isCustomMaterial" (change)="changeMaterialValue($event)"
                                                class="chkOverview">
                                        </div>
                                        <div>
                                            <span class="checkbox-style">Custom material</span>
                                        </div> -->

                    <div class="addtooltips align-self-baseline">
                      <ng-template #tipContent>
                        <div class="row">
                          <span
                            class="selectedMaterialDiv d-flex align-items-start justify-content-start"
                            >{{ materialname }}
                          </span>
                          <div
                            class="col-md-12 d-flex align-items-start justify-content-start pt-2"
                            *ngFor="let item of materialInfoData | keyvalue"
                          >
                            <ng-container *ngIf="item.key !== 'name'">
                              <span
                                class="col-4 d-flex align-items-start justify-content-start alignData"
                                >{{ toTitleCase(item.key) }}:
                              </span>
                              <span
                                class="col-8 d-flex align-items-start justify-content-start alignData"
                                >{{ item.value }}
                              </span>
                            </ng-container>
                          </div>
                        </div>
                      </ng-template>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="d-flex justify-content-end">
                    <div></div>
                    <!-- <div class="mb-3 d-flex justify-content-end align-items-center"
                                            [ngbPopover]="popContentOne" [autoClose]="false" triggers="manual"
                                            #popoverOne="ngbPopover">
                                            <a class="add-link" target="_blank"
                                                routerLink="custom/customMaterials"><span class="redirectLinkText">
                                                    Add custom material</span></a>
                                            <a class="setLinkIconPosition" target="_blank" replaceUrl="true"
                                                routerLink="custom/customMaterials">
                                                <img src="./assets/icons/redirect-icon.svg" alt="" width="15"
                                                    height="13">
                                            </a>
                                            <span class="setLinkIconPosition" (click)="getCustomMaterialList()"><img
                                                    src="./assets/icons/refresh-circle.svg" alt="" width="14"
                                                    height="13"></span>
                                        </div> -->
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group mat-dropdown">
                    <div class="row">
                      <div class="col-7">
                        <label
                          *ngIf="
                            projectPackMaterialForm.get('materialDetailForm')?.get('materialName')
                              ?.value
                          "
                          class="sub-header-drpdown pb-2"
                          >Selected material *</label
                        >
                      </div>
                      <div class="col-5">
                        <label class="about-data-text pb-2"
                          >Data quality information
                          <a
                            [ngbTooltip]="tipContent"
                            tooltipClass="material-data"
                            data-bs-placement="auto"
                            class="ms-2"
                            ><img
                              class="icon-bottom-spacing"
                              src="./assets/icons/material-info.svg" /></a
                        ></label>
                      </div>
                    </div>
                    <ng-select
                      [clearable]="true"
                      [clearOnBackspace]="false"
                      *ngIf="!isCustomMaterial"
                      class="accordion-text addScroll"
                      #material
                      [items]="materialItems"
                      [searchable]="false"
                      formControlName="materialName"
                      (change)="getMaterialValue($event)"
                      bindLabel="description"
                      bindValue="id"
                      [searchFn]="commonInputSearch"
                      placeholder="Select material"
                      [virtualScroll]="true"
                      groupBy="childItems"
                    >
                      <ng-template ng-header-tmp>
                        <div class="has-feedback">
                          <input
                            type="text"
                            class="accordion-search form-control search-input"
                            id="inputValidation"
                            (input)="material.filter($any($event.target).value)"
                            placeholder="Search..."
                          />
                          <span class="form-control-feedback">
                            <i class="fa fa-search icon"></i>
                          </span>
                        </div>
                      </ng-template>
                      <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
                        <div [ngOptionHighlight]="search" title="{{ item?.description }}">
                          {{ item?.description }}
                        </div>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                        <div [ngOptionHighlight]="search" title="{{ item?.description }}">
                          {{ item?.description }}
                        </div>
                      </ng-template>
                    </ng-select>
                    <ng-select
                      [clearable]="true"
                      [clearOnBackspace]="false"
                      *ngIf="isCustomMaterial"
                      [items]="customMaterialItems"
                      [searchable]="false"
                      #material
                      bindLabel="name"
                      formControlName="materialName"
                      (change)="getMaterialValue($event)"
                      [searchFn]="commonInputSearchForCountry"
                      placeholder="Select material"
                      class="accordion-text addScroll"
                      [virtualScroll]="true"
                    >
                      <ng-template ng-header-tmp>
                        <div class="has-feedback">
                          <input
                            type="text"
                            (input)="material.filter($any($event.target).value)"
                            class="accordion-search form-control search-input"
                            id="inputValidation"
                            placeholder="Search..."
                          />
                          <span class="form-control-feedback">
                            <i class="fa fa-search icon"></i>
                          </span>
                        </div>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                        <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                          {{ item.name }}
                        </div>
                      </ng-template>
                    </ng-select>
                    <div
                      *ngIf="
                        submittedForMaterial &&
                        projectPackMaterialForm.get('materialDetailForm')?.get('materialName')
                          ?.errors
                      "
                    >
                      <div
                        *ngIf="
                          projectPackMaterialForm.get('materialDetailForm')?.get('materialName')
                            ?.invalid
                        "
                        class="input-error"
                      >
                        Please select material
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group required">
                    <label
                      *ngIf="
                        projectPackMaterialForm.get('materialDetailForm')?.get('materialCountry')
                          ?.value
                      "
                      class="sub-header-drpdown pb-2"
                      >Selected country</label
                    >
                    <ng-select
                      [clearable]="true"
                      [clearOnBackspace]="false"
                      #country
                      [items]="materialRegion"
                      bindLabel="name"
                      [searchable]="false"
                      [searchFn]="commonInputSearchForCountry"
                      class="accordion-text addScroll"
                      placeholder="Select country"
                      formControlName="materialCountry"
                      (change)="getMaterialRegion($event)"
                      [virtualScroll]="materialRegion.length > 5 ? true : false"
                    >
                      <div *ngIf="materialRegion.length > 5">
                        <ng-template ng-header-tmp>
                          <div class="has-feedback">
                            <input
                              type="text"
                              (input)="country.filter($any($event.target).value)"
                              class="accordion-search form-control search-input"
                              id="inputValidation"
                              placeholder="Search..."
                            />
                            <span class="form-control-feedback">
                              <i class="fa fa-search icon"></i>
                            </span>
                          </div>
                        </ng-template>
                      </div>
                      <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                        <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                          {{ item.name }}
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
                <div class="col-md-6" id="mat-cert">
                  <div class="form-group required" aria-required="true">
                    <label
                      *ngIf="
                        projectPackMaterialForm.get('materialDetailForm')?.get('materialCountry')
                          ?.value
                      "
                      class="placeholder-sub-header pb-2"
                      >Holder_text</label
                    >
                    <div class="services-form">
                      <input
                        formControlName="materialWeigth"
                        type="number"
                        min="0"
                        oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                        maxlength="100"
                        placeholder="Weight of component (grams)"
                      />
                      <label>Weight of component (grams)</label>
                    </div>
                    <div
                      *ngIf="
                        submittedForMaterial &&
                        projectPackMaterialForm.get('materialDetailForm')?.get('materialWeigth')
                          ?.errors
                      "
                    >
                      <div
                        *ngIf="
                          projectPackMaterialForm.get('materialDetailForm')?.get('materialWeigth')
                            ?.invalid
                        "
                        class="input-error"
                      >
                        Weight of component (grams) is required
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6" *ngIf="isCostTrunOff">
                  <div class="form-group" aria-required="true">
                    <label *ngIf="showRecycledContent" class="sub-header-drpdown pb-2"
                      >Cost of material per kg {{ currrencyName }}</label
                    >
                    <div class="services-form-no-label">
                      <input
                        formControlName="materialCost"
                        type="number"
                        min="0"
                        oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                        [readOnly]="isCustomMaterial"
                        maxlength="100"
                        placeholder="Cost of material per kg {{ currrencyName }}"
                        [ngClass]="{ costDisabled: isCustomMaterial }"
                      />
                      <label *ngIf="!showRecycledContent && isCustomMaterial"
                        >Cost of material per kg {{ currrencyName }}</label
                      >
                    </div>
                  </div>
                </div>

                <div class="col-md-6" *ngIf="showRecycledContent && !isCustomMaterial">
                  <div class="form-group required" aria-required="true">
                    <label
                      class="sub-header-drpdown pb-2"
                      [ngbPopover]="popContentTwo"
                      [autoClose]="false"
                      triggers="manual"
                      #popoverTwo="ngbPopover"
                    >
                      Recycled content (%)</label
                    >
                    <span
                      placement="auto"
                      tooltipClass="sku-tooltip"
                      ngbTooltip="Global recycled content rates are displayed by default, if component specific recycled content rates are known, update here."
                    >
                      <a class="info-icon">
                        <span>
                          <img
                            src="./assets/icons/grey-question-icon.svg"
                            width="14"
                            height="14" /></span
                      ></a>
                    </span>
                    <div class="services-form-no-label">
                      <input
                        formControlName="materialRecycledContent"
                        type="number"
                        min="0"
                        oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                        maxlength="100"
                        placeholder="Recycled content (%)"
                        [readOnly]="organizationRecycleContent == 2"
                        [ngClass]="{ costDisabled: organizationRecycleContent == 2 }"
                      />
                    </div>
                    <div
                      *ngIf="submittedForMaterial && materialDetailForm.get('materialRecycledContent')?.errors?.['required']"
                      class="input-error"
                    >
                      The Recycled content (%) field is required.
                    </div>
                    <div
                      *ngIf="submittedForMaterial && (projectPackMaterialForm.get('materialDetailForm')?.get('materialRecycledContent')?.errors?.['min'] ||projectPackMaterialForm.get('materialDetailForm')?.get('materialRecycledContent')?.errors?.['max'])"
                      class="input-error"
                    >
                      Recycled content (%) must be in between 0 to 100
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group" aria-required="true">
                    <label
                      [ngbPopover]="popContentThree"
                      [autoClose]="false"
                      triggers="manual"
                      #popoverThree="ngbPopover"
                      *ngIf="
                        projectPackMaterialForm
                          .get('materialDetailForm')
                          ?.get('recyclableComponent')?.value
                      "
                      class="sub-header-drpdown pb-2"
                      >Recycling pathway</label
                    >
                    <label
                      *ngIf="
                        !isCostTrunOff &&
                        !projectPackMaterialForm
                          .get('materialDetailForm')
                          ?.get('recyclableComponent')?.value
                      "
                      class="placeholder-sub-header pb-2"
                      >placeholder_text</label
                    >
                    <label
                      *ngIf="
                        !(
                          projectPackMaterialForm
                            .get('materialDetailForm')
                            ?.get('recyclableComponent')?.value && !showRecycledContent
                        ) && isCustomMaterial
                      "
                      class="placeholder-sub-header pb-2"
                      >placeholder_text</label
                    >
                    <ng-select
                      [clearable]="true"
                      [clearOnBackspace]="false"
                      #recyclableComp
                      [items]="recyclableComponentList"
                      bindLabel="name"
                      [searchable]="false"
                      [searchFn]="commonInputSearchForCountry"
                      placeholder="Recycling pathway"
                      formControlName="recyclableComponent"
                      [virtualScroll]="recyclableComponentList.length > 5 ? true : false"
                      class="accordion-text addScroll"
                    >
                      <ng-template ng-header-tmp>
                        <div class="has-feedback">
                          <input
                            type="text"
                            class="form-control accordion-search search-input"
                            id="inputValidation"
                            placeholder="Search..."
                            (input)="recyclableComp.filter($any($event.target).value)"
                          />
                          <span class="form-control-feedback">
                            <i class="fa fa-search icon"></i>
                          </span>
                        </div>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                        <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                          {{ item.name }}
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <label class="subTitleName">Material certification</label>
                </div>
              </div>

              <div class="row d-flex">
                <div class="col-8">
                  <label class="material-cert"
                    >Tick the applicable certificates for the selected material</label
                  >
                </div>
                <div
                  class="col-4 update-cert"
                  *ngIf="roleName == 'Super Admin' || roleName == 'Admin'"
                >
                  <a routerLink="my-organization/organizationPreferences" target="_blank">
                    Update material certification</a
                  >
                  <a
                    class="setLinkIconPosition for-mat-cert"
                    target="_blank"
                    routerLink="my-organization/organizationPreferences"
                  >
                    <img src="./assets/icons/redirect-icon.svg" width="15" height="13" />
                  </a>
                  <span
                    class="setLinkIconPosition refresh-cert"
                    (click)="refreshMaterialCertificateNames()"
                    ><img src="./assets/icons/refresh-circle.svg" alt="" width="14" height="13"
                  /></span>
                </div>
              </div>

              <div class="row">
                <div
                  class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4"
                  *ngFor="let data of certificateData"
                >
                  <div class="certificate-alignment">
                    <div>
                      <input
                        type="checkbox"
                        id="{{ data?.typeId }}"
                        [checked]="
                          data?.typeId == 1
                            ? carbonNeutralValue
                            : data.typeId == 2
                            ? fscCertificationValue
                            : otherCertificationValue
                        "
                        (change)="selectedCertification($event)"
                        class="chkOverview"
                      />
                    </div>
                    <div class="parent-cert-div">
                      <span class="checkbox-style" title="{{ data?.name }}">{{ data?.name }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <hr class="my-4" />

            <div class="row" formGroupName="transportationDetailForm">
              <div class="col-12">
                <label class="subTitleName">Transportation to converter</label>
                <p class="gray-font">Select data entry for transport</p>
              </div>

              <!-- Transport buttons -->
              <div>
                <ul class="nav nav-pills nav-justified buttonTab" id="myTab" role="tablist">
                  <li
                    class="nav-item d-flex justify-content-around"
                    role="presentation"
                    (click)="manualLocation(data)"
                    *ngFor="let data of wholeData"
                    [ngbPopover]="popContentFour"
                    [autoClose]="false"
                    triggers="manual"
                    #popoverFour="ngbPopover"
                  >
                    <button
                      id="location-tab"
                      [ngClass]="
                        selectedBox?.id === data.transportaionId &&
                        (selectLocation || selectDistance || selectCustom)
                          ? 'nav-link active'
                          : 'nav-link'
                      "
                      type="button"
                    >
                      <div class="image">
                        <img
                          [src]="data.img"
                          [height]="data.heightImg"
                          [width]="data.widthImg"
                          alt=""
                        />
                      </div>
                      <div class="displayName">
                        <span
                          [ngClass]="
                            selectedBox?.id === data.transportaionId &&
                            (selectLocation || selectDistance || selectCustom)
                              ? 'active'
                              : ''
                          "
                          >{{ data.displayName }}</span
                        >
                      </div>
                    </button>
                  </li>
                </ul>
              </div>

              <!-- Transport button Content -->
              <div class="tab-content mt-3">
                <!-- Location -->
                <div class="fade show" *ngIf="selectLocation">
                  <div class="row my-2">
                    <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 customTruckCheckBox">
                      <div
                        class="d-flex checkBoxAlienMent"
                        *ngIf="projectPackMaterialTransportScenarioList?.length > 0"
                      >
                        <div>
                          <input
                            type="checkbox"
                            class="chkOverview"
                            [ngModelOptions]="{ standalone: true }"
                            [(ngModel)]="isCustomTruck"
                            (change)="
                              chnageCustomTruck(
                                $event,
                                getConversionList,
                                projectPackMaterialTransportScenarioList
                              )
                            "
                          />
                        </div>
                        <div>
                          <span class="checkbox-style">Custom truck</span>
                        </div>
                      </div>
                      <div class="d-flex checkBoxAlienMent">
                        <div>
                          <input type="checkbox" class="chkOverview" (change)="showPorts($event)" />
                        </div>
                        <div>
                          <span class="checkbox-style">Show only ports</span>
                        </div>
                      </div>
                    </div>
                    <ng-container
                      *ngrxLet="projectFacde.distanceErrorProject$ as distanceErrorProject"
                    >
                      <div class="mt-3" *ngIf="distanceErrorProject != ''">
                        <span class="input-error-distance">{{ distanceErrorProject }}</span>
                      </div>
                    </ng-container>

                    <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                      <div
                        class="d-flex justify-content-start justify-content-sm-start justify-content-md-start justify-content-lg-end justify-content-xl-end justify-content-end"
                      >
                        <div></div>

                        <div *ngIf="isCustomTruck">
                          <a class="add-link" target="_blank" routerLink="custom/customTrucks"
                            ><span class="redirectLinkText">Add custom truck</span></a
                          >
                          <a
                            class="setLinkIconPosition"
                            target="_blank"
                            replaceUrl="true"
                            routerLink="custom/customTrucks"
                          >
                            <img
                              src="./assets/icons/redirect-icon.svg"
                              alt=""
                              width="15"
                              height="13"
                            />
                          </a>
                          <span class="setLinkIconPosition" (click)="getCustomTruckList()"
                            ><img
                              src="./assets/icons/refresh-circle.svg"
                              alt=""
                              width="14"
                              height="13"
                          /></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <label
                      *ngIf="!!isValidPort && projectPackMaterialTransportScenarioList?.length > 0"
                      class="input-error ms-2"
                      >{{ isValidPort }}</label
                    >
                  </div>
                  <div>
                    <ng-container *ngIf="projectPackMaterialTransportScenarioList?.length">
                      <piqet-angular-portlet
                        [columnDefs]="processColumnDef"
                        [isSetWidth]="true"
                        [frameworkComponents]="frameworkComponents"
                        [class]="'detail-cell-renderer'"
                        [gridData]="projectPackMaterialTransportScenarioList"
                        [hideSearch]="true"
                        [hidePagination]="true"
                        [gridName]="'pack material manual location'"
                      >
                      </piqet-angular-portlet>
                    </ng-container>
                  </div>
                  <ng-template #other_content>
                    <div class="row">
                      <div class="col-6">
                        <div class="d-flex justify-content-end align-items-end">
                          <p class="highlights" placeholder="Origin">
                            Select locations with "(Port)" for shipping
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="row pb-3">
                      <div class="col-md-6">
                        <div class="form-group inputLable required">
                          <div class="ng-autocomplete autocomplete">
                            <ng-autocomplete
                              #autoForOrigin
                              [isLoading]="isLoading"
                              (inputCleared)="onClearSearch($event)"
                              [data]="selectedCities"
                              class="supplierdrpdown"
                              [searchKeyword]="keyword"
                              (inputChanged)="onSearch($event)"
                              historyIdentifier="selectedCities"
                              (selected)="selectEvent($event)"
                              [itemTemplate]="itemTemplate"
                              placeholder="Origin"
                              [notFoundTemplate]="notFoundTemplate"
                              formControlName="Origin"
                              (scrolledToEnd)="onScroll()"
                              [(ngModel)]="keywordAuto"
                              (keydown)="onKeyDownEvent($event)"
                            >
                            </ng-autocomplete>

                            <ng-template #itemTemplate let-item>
                              <div class="item"><span [innerHTML]="item.name"></span> &nbsp;</div>
                            </ng-template>

                            <ng-template #notFoundTemplate let-notFound>
                              <div [innerHTML]="notFound"></div>
                            </ng-template>
                          </div>
                        </div>
                        <div
                          *ngIf="
                            setOriginsubmitted &&
                            !this.transportationDetailForm.controls[
                              'Origin'
                            ]?.value?.hasOwnProperty('name')
                          "
                          class="input-error"
                        >
                          Select city from list.
                        </div>
                      </div>
                      <div class="col-sm-1 aligniconQuestion">
                        <span
                          placement="auto"
                          tooltipClass="sku-tooltip"
                          ngbTooltip="Hint: For automatic calculation of sea distance the origin and destination should be the cities with (Port)"
                        >
                          <a class="info-icon">
                            <span>
                              <img
                                src="./assets/icons/grey-question-icon.svg"
                                width="14"
                                height="14"
                            /></span>
                          </a>
                        </span>
                      </div>
                      <div class="col-md-5">
                        <div>
                          <button
                            class="modelBtn setOriginBtn pull-right"
                            *ngIf="!isCheckUpdateOrigin"
                            (click)="setOrigin(projectPackMaterialTransportScenarioList)"
                          >
                            Set origin
                          </button>
                          <button
                            class="modelBtn setOriginBtn pull-right"
                            *ngIf="isCheckUpdateOrigin"
                            (click)="setOrigin(projectPackMaterialTransportScenarioList)"
                          >
                            Update
                          </button>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  <div
                    class="row mt-3"
                    *ngIf="projectPackMaterialTransportScenarioList?.length > 0 && !checkIsOrginBtn"
                  >
                    <div class="col-4">
                      <div class="d-flex justify-content-end align-items-end">
                        <p
                          class="highlights"
                          [ngClass]="
                            transportationDetailForm.controls['transportModeForLocation'].value
                              ? 'custom-text-position'
                              : ''
                          "
                          placeholder="Origin"
                        >
                          Select locations with "(Port)" for shipping
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    *ngIf="
                      projectPackMaterialTransportScenarioList?.length > 0 && !checkIsOrginBtn;
                      else other_content
                    "
                    class="row"
                  >
                    <div class="col-md-4">
                      <label
                        *ngIf="transportationDetailForm.controls['transportModeForLocation'].value"
                        class="placeholder-sub-header pb-2"
                        >Holder_text</label
                      >
                      <div>
                        <ng-autocomplete
                          #autoForDestination
                          [isLoading]="isLoading"
                          (inputCleared)="onClearSearch($event)"
                          [data]="selectedCities"
                          class="supplierdrpdown"
                          [searchKeyword]="keyword"
                          historyIdentifier="selectedCities"
                          [itemTemplate]="itemTemplate"
                          (selected)="selectEvent($event)"
                          [notFoundTemplate]="notFoundTemplate"
                          placeholder="Destination"
                          formControlName="destination"
                          (inputChanged)="onSearch($event)"
                          (scrolledToEnd)="onScroll()"
                          [(ngModel)]="keywordAuto"
                          (keydown)="onKeyDownEvent($event)"
                        >
                        </ng-autocomplete>

                        <ng-template #itemTemplate let-item>
                          <div class="item"><span [innerHTML]="item.name"></span> &nbsp;</div>
                        </ng-template>

                        <ng-template #notFoundTemplate let-notFound>
                          <div [innerHTML]="notFound"></div>
                        </ng-template>
                      </div>

                      <div
                        *ngIf="
                          setDestinationsubmitted &&
                          !this.transportationDetailForm.controls[
                            'destination'
                          ]?.value?.hasOwnProperty('name')
                        "
                        class="input-error destinatioErrorMessage"
                      >
                        Select city from list.
                      </div>
                    </div>
                    <div class="col-md-4" *ngIf="!isCustomTruck">
                      <div class="required" aria-required="true">
                        <label
                          *ngIf="
                            transportationDetailForm.controls['transportModeForLocation'].value
                          "
                          class="sub-header-drpdown pb-2"
                          >Transport mode</label
                        >
                        <ng-select
                          [clearable]="true"
                          [clearOnBackspace]="false"
                          #select
                          [items]="transportModeItems"
                          [searchable]="false"
                          class="addScroll"
                          formControlName="transportModeForLocation"
                          (change)="changeTransportMode($event)"
                          bindLabel="name"
                          [searchFn]="commonInputSearchForCountry"
                          placeholder="Select transport mode"
                          [virtualScroll]="true"
                        >
                          <ng-template ng-header-tmp>
                            <div class="has-feedback">
                              <input
                                type="text"
                                class="form-control search-input search"
                                id="inputValidation"
                                placeholder="Search..."
                                (input)="select.filter($any($event.target).value)"
                              />
                              <span class="form-control-feedback">
                                <i class="fa fa-search icon"></i>
                              </span>
                            </div>
                          </ng-template>
                          <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                            <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                              {{ item.name }}
                            </div>
                          </ng-template>
                        </ng-select>
                      </div>
                      <div
                        *ngIf="
                          setDestinationsubmitted &&
                          !transportationDetailForm.controls['transportModeForLocation'].value
                        "
                        class="input-error"
                      >
                        please select transport mode
                      </div>
                    </div>

                    <div class="col-md-4" *ngIf="isCustomTruck">
                      <div class="required" aria-required="true">
                        <label
                          *ngIf="
                            transportationDetailForm.controls['transportModeForLocation'].value
                          "
                          class="sub-header-drpdown pb-2"
                          >Transport mode</label
                        >
                        <ng-select
                          [clearable]="true"
                          [clearOnBackspace]="false"
                          #select
                          [items]="customTruckItems"
                          [searchable]="false"
                          class="addScroll"
                          formControlName="transportModeForLocation"
                          (change)="changeTransportMode($event)"
                          bindLabel="name"
                          [searchFn]="commonInputSearchForCountry"
                          placeholder="Select transport mode"
                          [virtualScroll]="true"
                        >
                          <ng-template ng-header-tmp>
                            <div class="has-feedback">
                              <input
                                type="text"
                                class="form-control search-input search"
                                id="inputValidation"
                                (input)="select.filter($any($event.target).value)"
                                placeholder="Search..."
                              />
                              <span class="form-control-feedback">
                                <i class="fa fa-search icon"></i>
                              </span>
                            </div>
                          </ng-template>
                          <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                            <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                              {{ item.name }}
                            </div>
                          </ng-template>
                        </ng-select>
                      </div>
                      <div
                        *ngIf="
                          setDestinationsubmitted &&
                          !transportationDetailForm.controls['transportModeForLocation'].value
                        "
                        class="input-error"
                      >
                        please select transport mode
                      </div>
                    </div>
                    <div class="col-md-4" *ngIf="isCheckUpdateDestination">
                      <div class="form-group required" aria-required="true">
                        <label
                          *ngIf="
                            transportationDetailForm.controls['transportModeForLocation'].value
                          "
                          class="placeholder-sub-header pb-2"
                          >Holder_text</label
                        >
                        <div class="services-form">
                          <input
                            (keydown)="noSpecialKeys($event)"
                            placeholder="Distance"
                            formControlName="distanceManulaLocation"
                          />
                          <label>Distance </label>
                        </div>
                        <div *ngIf="setDestinationsubmitted">
                          <div
                            *ngIf="
                              transportationDetailForm.controls['distanceManulaLocation'].value == 0
                            "
                            class="input-error"
                          >
                            Distance must be greater than 0
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-3">
                      <label
                        *ngIf="transportationDetailForm.controls['transportModeForLocation'].value"
                        class="placeholder-sub-header pb-2"
                        >Holder_text</label
                      >
                      <div>
                        <button
                          class="modelBtn setOriginBtn"
                          *ngIf="!isCheckUpdateDestination"
                          (click)="setDestination()"
                        >
                          Add transport leg
                        </button>
                        <button
                          class="modelBtn setOriginBtn"
                          *ngIf="isCheckUpdateDestination"
                          (click)="setDestination()"
                        >
                          Update
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Distance -->
                <div class="fade show" *ngIf="selectDistance">
                  <div class="row my-3">
                    <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                      <div class="d-flex checkBoxAlienMent">
                        <div
                          *ngrxLet="
                            projectFacde.getTransportScenarioListFordistance$ as getTransportScenarioListFordistance
                          "
                        >
                          <input
                            type="checkbox"
                            class="chkOverview"
                            [ngModelOptions]="{ standalone: true }"
                            [(ngModel)]="isCustomTruck"
                            (change)="
                              chnageCustomTruck(
                                $event,
                                getConversionList,
                                getTransportScenarioListFordistance
                              )
                            "
                          />
                        </div>
                        <div [attr.isCustomTruck]="isCustomTruck ? true : null">
                          <span class="checkbox-style">Custom truck</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                      <div
                        class="d-flex justify-content-start justify-content-sm-start justify-content-md-start justify-content-lg-end justify-content-xl-end justify-content-end"
                      >
                        <div></div>
                        <div>
                          <a class="add-link" target="_blank" routerLink="custom/customTrucks"
                            ><span class="redirectLinkText">Add custom truck</span></a
                          >
                          <a
                            class="setLinkIconPosition"
                            target="_blank"
                            replaceUrl="true"
                            routerLink="custom/customTrucks"
                          >
                            <img
                              src="./assets/icons/redirect-icon.svg"
                              alt=""
                              width="15"
                              height="13"
                            />
                          </a>
                          <span class="setLinkIconPosition" (click)="getCustomTruckList()"
                            ><img
                              src="./assets/icons/refresh-circle.svg"
                              alt=""
                              width="14"
                              height="13"
                          /></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    *ngrxLet="
                      projectFacde.getTransportScenarioListFordistance$ as getTransportScenarioListFordistance
                    "
                  >
                    <ng-container *ngIf="getTransportScenarioListFordistance?.length > 0">
                      <piqet-angular-portlet
                        [columnDefs]="distanceProcessColumnDef"
                        [isSetWidth]="true"
                        [frameworkComponents]="frameworkComponents"
                        [gridData]="getTransportScenarioListFordistance"
                        [hideSearch]="true"
                        [hidePagination]="true"
                        [gridName]="'Project pack Material manual distance'"
                      >
                      </piqet-angular-portlet>
                    </ng-container>
                  </div>
                  <div class="row mt-3">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                      <div class="form-group required" aria-required="true" *ngIf="!isCustomTruck">
                        <label
                          *ngIf="
                            transportationDetailForm.controls['transportModeForDistance'].value
                          "
                          class="sub-header-drpdown pb-2"
                          >Transport mode</label
                        >
                        <ng-select
                          [clearable]="true"
                          [clearOnBackspace]="false"
                          #select
                          [items]="transportModeItems"
                          [searchable]="false"
                          class="addScroll"
                          formControlName="transportModeForDistance"
                          (change)="changeTransportModeManudalDis($event)"
                          bindLabel="name"
                          [searchFn]="commonInputSearchForCountry"
                          placeholder="Transport mode"
                          [virtualScroll]="true"
                        >
                          <ng-template ng-header-tmp>
                            <div class="has-feedback">
                              <input
                                type="text"
                                class="form-control search-input search"
                                id="inputValidation"
                                (input)="select.filter($any($event.target).value)"
                                placeholder="Search..."
                              />
                              <span class="form-control-feedback">
                                <i class="fa fa-search icon"></i>
                              </span>
                            </div>
                          </ng-template>
                          <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                            <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                              {{ item.name }}
                            </div>
                          </ng-template>
                        </ng-select>
                        <div
                          *ngIf="
                            setManualDistanceSubmitted &&
                            !transportationDetailForm.controls['transportModeForDistance'].value
                          "
                          class="input-error"
                        >
                          please select transport mode
                        </div>
                      </div>
                      <div class="required" aria-required="true" *ngIf="isCustomTruck">
                        <label
                          *ngIf="
                            transportationDetailForm.controls['transportModeForDistance'].value
                          "
                          class="sub-header-drpdown pb-2"
                          >Transport mode</label
                        >
                        <ng-select
                          [clearable]="true"
                          [clearOnBackspace]="false"
                          #select
                          [items]="customTruckItems"
                          [searchable]="false"
                          class="addScroll"
                          formControlName="transportModeForDistance"
                          (change)="changeTransportModeManudalDis($event)"
                          bindLabel="name"
                          [searchFn]="commonInputSearchForCountry"
                          placeholder="Transport mode"
                          [virtualScroll]="true"
                        >
                          <ng-template ng-header-tmp>
                            <div class="has-feedback">
                              <input
                                type="text"
                                placeholder="Search..."
                                class="form-control search-input search"
                                id="inputValidation"
                                (input)="select.filter($any($event.target).value)"
                              />
                              <span class="form-control-feedback">
                                <i class="fa fa-search icon"></i>
                              </span>
                            </div>
                          </ng-template>
                          <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                            <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                              {{ item.name }}
                            </div>
                          </ng-template>
                        </ng-select>
                        <div
                          *ngIf="
                            setManualDistanceSubmitted &&
                            !transportationDetailForm.controls['transportModeForDistance'].value
                          "
                          class="input-error"
                        >
                          please select transport mode
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                      <div class="form-group required" aria-required="true">
                        <label
                          *ngIf="
                            transportationDetailForm.controls['transportModeForDistance'].value
                          "
                          class="placeholder-sub-header pb-2"
                          >Holder_text</label
                        >
                        <div class="services-form">
                          <input
                            type="number"
                            maxlength="100"
                            min="0"
                            [placeholder]="DISTANCE_KM_LABEL"
                            formControlName="distance"
                            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                          />
                          <label>{{ DISTANCE_KM_LABEL }}</label>
                        </div>
                        <div *ngIf="setManualDistanceSubmitted">
                          <div
                            *ngIf="transportationDetailForm.controls['distance'].value === 0"
                            class="input-error"
                          >
                            Distance must be greater than 0
                          </div>
                        </div>
                        <div
                          *ngIf="
                            setManualDistanceSubmitted &&
                            !transportationDetailForm.controls['distance'].value &&
                            transportationDetailForm.controls['distance'].value !== 0
                          "
                          class="input-error"
                        >
                          please select distance
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                      <div class="add-button">
                        <button
                          class="purple-button"
                          *ngIf="!isCheckEditManudalDist"
                          (click)="addTransportDistance()"
                        >
                          Add transport leg
                        </button>
                        <button
                          class="purple-button"
                          *ngIf="isCheckEditManudalDist"
                          (click)="addTransportDistance()"
                        >
                          Update
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Custom -->
                <div class="fade show" *ngIf="selectCustom">
                  <div class="row">
                    <div class="col-12">
                      <div class="d-flex justify-content-end">
                        <div style="margin: 1rem 0rem">
                          <a class="add-link" target="_blank" routerLink="custom/customTransport"
                            ><span class="redirectLinkText">Add custom transport scenario</span></a
                          >
                          <a
                            class="setLinkIconPosition"
                            target="_blank"
                            replaceUrl="true"
                            routerLink="custom/customTransport"
                          >
                            <img
                              src="./assets/icons/redirect-icon.svg"
                              alt=""
                              width="15"
                              height="13"
                            />
                          </a>
                          <span class="setLinkIconPosition" (click)="getCustomTransport()"
                            ><img
                              src="./assets/icons/refresh-circle.svg"
                              alt=""
                              width="14"
                              height="13"
                          /></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                      <div class="form-group required">
                        <label
                          *ngIf="transportationDetailForm.controls['customScenarioItem']?.value"
                          class="sub-header-drpdown pb-2"
                          >Selected custom freight mode</label
                        >
                        <ng-select
                          [clearable]="true"
                          [clearOnBackspace]="false"
                          #select
                          [items]="customtransportScenarioItems"
                          [searchable]="false"
                          formControlName="customScenarioItem"
                          class="accordion-text addScroll"
                          bindLabel="name"
                          (change)="changeCustomTransportItem($event)"
                          (clear)="resetTransport()"
                          [searchFn]="commonInputSearchForCountry"
                          placeholder="Select custom freight mode"
                          [virtualScroll]="customtransportScenarioItems.length > 5 ? true : false"
                        >
                          <ng-template ng-header-tmp>
                            <div class="has-feedback">
                              <input
                                class="search"
                                type="text"
                                class="form-control search-input"
                                id="inputValidation"
                                (input)="select.filter($any($event.target).value)"
                                placeholder="Search..."
                              />
                              <span class="form-control-feedback">
                                <i class="fa fa-search icon"></i>
                              </span>
                            </div>
                          </ng-template>
                          <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                            <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                              {{ item.name }}
                            </div>
                          </ng-template>
                        </ng-select>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                      <div class="add-button">
                        <button class="purple-button" (click)="addCustomFreight()">
                          Add transport leg
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  *ngrxLet="
                    projectFacde.getCustomTransoportScenarioDetailViewModels$ as getCustomTransoportScenarioDetailViewModels
                  "
                >
                  <div
                    *ngIf="
                      isShowCustomTransportList ||
                      getCustomTransoportScenarioDetailViewModels?.length > 0
                    "
                  >
                    <piqet-angular-portlet
                      [columnDefs]="customTransportDef"
                      [gridData]="
                        customTransportList || getCustomTransoportScenarioDetailViewModels
                      "
                      [hideSearch]="true"
                      [hidePagination]="true"
                      [isSetWidth]="true"
                      [gridName]="'pack material custom transport'"
                    >
                    </piqet-angular-portlet>
                  </div>
                </div>
              </div>
            </div>
            <hr class="my-4" />
            <div formGroupName="conversionDetailForm">
              <div class="w-fit-content">
                <h5
                  [ngbPopover]="popContentFive"
                  triggers="manual"
                  [autoClose]="false"
                  #popoverFive="ngbPopover"
                >
                  Conversion process
                </h5>
              </div>

              <div class="d-flex my-3">
                <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
                  <div class="d-flex checkBoxAlienMent">
                    <div>
                      <input
                        type="checkbox"
                        (change)="chnageRecommendedConversion($event, getConversionList)"
                        [(ngModel)]="isRecommendedConversionProcess"
                        formControlName="isRecommendedConversionProcess"
                        class="chkOverview"
                      />
                    </div>
                    <div>
                      <span class="checkbox-style">Recommended conversions</span>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 px-3">
                  <div class="d-flex checkBoxAlienMent">
                    <div>
                      <input
                        type="checkbox"
                        class="chkOverview"
                        formControlName="isAreabasedConversion"
                        [(ngModel)]="isAreaBaseConversionProcess"
                        (change)="areabasedConversion($event)"
                      />
                    </div>
                    <div>
                      <span class="checkbox-style">Area based conversions</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row my-3">
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                  <div class="d-flex checkBoxAlienMent">
                    <!-- <div>
                                            <input type="checkbox" class="chkOverview"
                                                formControlName="isCustomConversion" [(ngModel)]="isCustomConversion"
                                                (change)="changeCustyomConversion($event, getConversionList)">
                                        </div>
                                        <div>
                                            <span class="checkbox-style">Custom conversions</span>
                                        </div> -->
                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                  <div
                    class="d-flex justify-content-start justify-content-sm-start justify-content-md-start justify-content-lg-end justify-content-xl-end"
                  >
                    <div></div>
                    <div *ngIf="isCustomConversion">
                      <div>
                        <a class="add-link" target="_blank" routerLink="custom/customConversion"
                          ><span class="redirectLinkText">Add custom conversion</span></a
                        >
                        <a
                          class="setLinkIconPosition"
                          target="_blank"
                          replaceUrl="true"
                          routerLink="custom/customConversion"
                        >
                          <img
                            src="./assets/icons/redirect-icon.svg"
                            alt=""
                            width="15"
                            height="13"
                          />
                        </a>
                        <span class="setLinkIconPosition" (click)="getCustomConversionProcessList()"
                          ><img
                            src="./assets/icons/refresh-circle.svg"
                            alt=""
                            width="14"
                            height="13"
                        /></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div
                    class="form-group required"
                    *ngIf="
                      !isRecommendedConversionProcess &&
                      !isAreaBaseConversionProcess &&
                      !isCustomConversion
                    "
                  >
                    <label
                      *ngIf="conversionDetailForm.controls['conversion']?.value"
                      class="sub-header-drpdown pb-2"
                      >Conversion process</label
                    >
                    <ng-select
                      [clearable]="true"
                      [clearOnBackspace]="false"
                      class="accordion-text addScroll"
                      #material
                      [items]="conversionNoSelectedProcessItems"
                      [searchable]="false"
                      formControlName="conversion"
                      bindLabel="name"
                      [searchFn]="commonInputSearchForCountry"
                      placeholder="Select conversion process"
                      groupBy="childItems"
                      [virtualScroll]="true"
                    >
                      <ng-template ng-header-tmp>
                        <div class="has-feedback">
                          <input
                            type="text"
                            class="accordion-search form-control search-input"
                            id="inputValidation"
                            (input)="material.filter($any($event.target).value)"
                            placeholder="Search..."
                          />
                          <span class="form-control-feedback">
                            <i class="fa fa-search icon"></i>
                          </span>
                        </div>
                      </ng-template>
                      <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
                        <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                          {{ item?.name }}
                        </div>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                        <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                          {{ item?.name }}
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                  <div class="form-group required" *ngIf="isRecommendedConversionProcess">
                    <label
                      *ngIf="conversionDetailForm.controls['conversion']?.value"
                      class="sub-header-drpdown pb-2"
                      >Conversion process</label
                    >
                    <ng-select
                      [clearable]="true"
                      [clearOnBackspace]="false"
                      class="accordion-text addScroll"
                      #material
                      [items]="conversionProcessItems"
                      [searchable]="false"
                      formControlName="conversion"
                      bindLabel="name"
                      [searchFn]="commonInputSearchForCountry"
                      placeholder="Select conversion process"
                      groupBy="childItems"
                      [virtualScroll]="true"
                    >
                      <ng-template ng-header-tmp>
                        <div class="has-feedback">
                          <input
                            type="text"
                            class="accordion-search form-control search-input"
                            id="inputValidation"
                            (input)="material.filter($any($event.target).value)"
                            placeholder="Search..."
                          />
                          <span class="form-control-feedback">
                            <i class="fa fa-search icon"></i>
                          </span>
                        </div>
                      </ng-template>
                      <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
                        <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                          {{ item?.name }}
                        </div>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                        <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                          {{ item?.name }}
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                  <div class="form-group required" *ngIf="isAreaBaseConversionProcess">
                    <label
                      *ngIf="conversionDetailForm.controls['conversion']?.value"
                      class="sub-header-drpdown pb-2"
                      >Conversion process</label
                    >
                    <ng-select
                      [clearable]="true"
                      [clearOnBackspace]="false"
                      class="accordion-text addScroll"
                      #material
                      [items]="areaConversionItems"
                      [searchable]="false"
                      bindLabel="description"
                      [searchFn]="commonInputSearch"
                      placeholder="Select conversion process"
                      groupBy="childItems"
                      formControlName="conversion"
                      [virtualScroll]="true"
                    >
                      <ng-template ng-header-tmp>
                        <div class="has-feedback">
                          <input
                            type="text"
                            class="accordion-search form-control search-input"
                            id="inputValidation"
                            (input)="material.filter($any($event.target).value)"
                            placeholder="Search..."
                          />
                          <span class="form-control-feedback">
                            <i class="fa fa-search icon"></i>
                          </span>
                        </div>
                      </ng-template>
                      <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
                        <div [ngOptionHighlight]="search" title="{{ item?.description }}">
                          {{ item?.description }}
                        </div>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                        <div [ngOptionHighlight]="search" title="{{ item?.description }}">
                          {{ item?.description }}
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                  <div class="form-group required" *ngIf="isCustomConversion">
                    <label
                      *ngIf="conversionDetailForm.controls['conversion']?.value"
                      class="sub-header-drpdown pb-2"
                      >Conversion process</label
                    >
                    <ng-select
                      [clearable]="true"
                      [clearOnBackspace]="false"
                      class="accordion-text addScroll"
                      #material
                      [items]="customConversionItems"
                      [searchable]="false"
                      bindLabel="name"
                      [searchFn]="commonInputSearchForCountry"
                      placeholder="Select conversion process"
                      formControlName="conversion"
                      [virtualScroll]="true"
                    >
                      <ng-template ng-header-tmp>
                        <div class="has-feedback">
                          <input
                            type="text"
                            class="accordion-search form-control search-input"
                            id="inputValidation"
                            (input)="material.filter($any($event.target).value)"
                            placeholder="Search..."
                          />
                          <span class="form-control-feedback">
                            <i class="fa fa-search icon"></i>
                          </span>
                        </div>
                      </ng-template>
                      <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
                        <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                          {{ item?.name }}
                        </div>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                        <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                          {{ item?.name }}
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group required">
                    <label
                      *ngIf="conversionDetailForm.controls['country']?.value"
                      class="sub-header-drpdown pb-2"
                      >Country</label
                    >
                    <ng-select
                      [clearable]="true"
                      [clearOnBackspace]="false"
                      #countryConversion
                      [items]="conversionRegion"
                      bindLabel="name"
                      class="accordion-text addScroll"
                      [searchable]="false"
                      [searchFn]="commonInputSearchForCountry"
                      placeholder="Select country"
                      formControlName="country"
                      [virtualScroll]="true"
                    >
                      <div *ngIf="conversionRegion.length > 5">
                        <ng-template ng-header-tmp>
                          <div class="has-feedback">
                            <input
                              type="text"
                              (input)="countryConversion.filter($any($event.target).value)"
                              class="accordion-search form-control search-input"
                              id="inputValidation"
                              placeholder="Search..."
                            />
                            <span class="form-control-feedback">
                              <i class="fa fa-search icon"></i>
                            </span>
                          </div>
                        </ng-template>
                      </div>
                      <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                        <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                          {{ item.name }}
                        </div>
                      </ng-template>
                    </ng-select>
                    <div
                      *ngIf="
                        addConversionSubmitted &&
                        !this.conversionDetailForm.controls['country'].value
                      "
                      class="input-error"
                    >
                      Country is required
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="isCostTrunOff">
                <div class="col-md-12">
                  <div class="form-group" aria-required="true">
                    <div class="services-form">
                      <input
                        formControlName="conversionCost"
                        type="number"
                        min="0"
                        oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                        maxlength="30"
                        placeholder="Cost of conversion per kg {{ currrencyName }}"
                      />
                      <label>Cost of conversion per kg {{ currrencyName }} </label>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div class="col-md-12" *ngIf="isAreaBaseConversionProcess">
                  <div class="form-group" aria-required="true">
                    <div class="services-form">
                      <input
                        formControlName="area"
                        type="number"
                        min="0"
                        oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                        maxlength="100"
                        placeholder="Area cm2"
                      />
                      <label>Area cm2</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                  <div class="form-group required" aria-required="true">
                    <div>
                      <ng-autocomplete
                        [data]="supplier"
                        class="supplierdrpdown"
                        [searchKeyword]="keyword"
                        historyIdentifier="supplier"
                        [itemTemplate]="itemTemplate"
                        [notFoundTemplate]="notFoundTemplate"
                        formControlName="converter"
                        placeholder="Converter"
                      >
                      </ng-autocomplete>
                      <ng-template #itemTemplate let-item>
                        <div class="item"><span [innerHTML]="item.name"></span> &nbsp;</div>
                      </ng-template>

                      <ng-template #notFoundTemplate let-notFound>
                        <div [innerHTML]="notFound"></div>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="commonBtnMarginForGrid">
                    <button
                      class="modelBtn addLightGray"
                      [disabled]="!conversionDetailForm.controls['conversion'].value"
                      (click)="addConversion(getConversionList)"
                    >
                      Add
                    </button>
                  </div>
                </div>
              </div>
              <div>
                <ng-container *ngIf="getConversionList.length > 0">
                  <piqet-angular-portlet
                    [columnDefs]="conversionProcessColumnDef"
                    [frameworkComponents]="frameworkComponentsForConversion"
                    [gridData]="getConversionList"
                    [hideSearch]="true"
                    [hidePagination]="true"
                    [isSetWidth]="true"
                    [gridName]="'Project pack Material conversion'"
                    (inlineDataEditEvent)="editConversionProcess($event)"
                    [isChekIniline]="true"
                  >
                  </piqet-angular-portlet>
                </ng-container>
              </div>
            </div>
            <div class="setButtonAndError text-margin">
              <div
                class="modal-footer"
                *ngrxLet="{
                  conversionItem: (projectFacde.getConversionList$ | async),
                  getTransportScenarioListFordistance:
                    (projectFacde.getTransportScenarioListFordistance$ | async),
                  projectPackMaterialTransportScenarioList:
                    (projectFacde.projectPackMaterialTransportScenarioList$ | async)
                } as packMaterialList"
              >
                <button type="button" class="btn btn-light cancelBtn" (click)="onClose()">
                  Cancel
                </button>
                <button
                  type="button"
                  class="modelBtn purpleBtnHoverEffect"
                  (click)="
                    saveData(
                      packMaterialList.conversionItem,
                      packMaterialList.getTransportScenarioListFordistance,
                      packMaterialList.projectPackMaterialTransportScenarioList
                    )
                  "
                >
                  Save
                </button>
              </div>

              <div
                class="redErrorTag"
                *ngIf="submittedForComponent && submittedForMaterial && (projectPackMaterialForm.get('componentDetailForm')?.get('componentName')?.invalid || projectPackMaterialForm.get('componentDetailForm')?.get('packagingLevels')?.invalid || projectPackMaterialForm.get('materialDetailForm')?.get('materialName')?.invalid || projectPackMaterialForm.get('materialDetailForm')?.get('materialWeigth')?.invalid ||  materialDetailForm.get('materialRecycledContent')?.invalid || (projectPackMaterialForm.get('materialDetailForm')?.get('materialRecycledContent')?.errors?.['min'] ||projectPackMaterialForm.get('materialDetailForm')?.get('materialRecycledContent')?.errors?.['max']))"
              >
                <div class="bigScreenErrContain">
                  <div>
                    <span>
                      <img src="./assets/icons/swalDeletion.svg" width="53" height="48"
                    /></span>
                  </div>
                  <div>
                    <div class="mb-3">
                      <span class="alert-error"
                        >To proceed please complete the following fields :
                      </span>
                    </div>
                    <div
                      class="topBottomCss"
                      *ngIf="
                        submittedForComponent &&
                        projectPackMaterialForm.get('componentDetailForm')?.get('componentName')
                          ?.errors
                      "
                    >
                      <div
                        class="alert-error"
                        *ngIf="
                          projectPackMaterialForm.get('componentDetailForm')?.get('componentName')
                            ?.invalid ||
                          componentDetailForm.controls['componentName'].hasError('whitespace')
                        "
                      >
                        Component name
                      </div>
                    </div>
                    <div
                      class="topBottomCss"
                      *ngIf="
                        submittedForComponent &&
                        projectPackMaterialForm.get('componentDetailForm')?.get('packagingLevels')
                          ?.errors
                      "
                    >
                      <div
                        class="alert-error"
                        *ngIf="
                          projectPackMaterialForm.get('componentDetailForm')?.get('packagingLevels')
                            ?.invalid
                        "
                      >
                        Packaging level
                      </div>
                    </div>
                    <div
                      class="topBottomCss"
                      *ngIf="
                        submittedForMaterial &&
                        projectPackMaterialForm.get('materialDetailForm')?.get('materialName')
                          ?.errors
                      "
                    >
                      <div
                        class="alert-error"
                        *ngIf="
                          projectPackMaterialForm.get('materialDetailForm')?.get('materialName')
                            ?.invalid
                        "
                      >
                        Material
                      </div>
                    </div>
                    <div
                      class="topBottomCss"
                      *ngIf="
                        submittedForMaterial &&
                        projectPackMaterialForm.get('materialDetailForm')?.get('materialWeigth')
                          ?.errors
                      "
                    >
                      <div
                        class="alert-error"
                        *ngIf="
                          projectPackMaterialForm.get('materialDetailForm')?.get('materialWeigth')
                            ?.invalid
                        "
                      >
                        Weight of component (grams)
                      </div>
                    </div>
                    <div class="topBottomCss">
                      <div
                        class="alert-error"
                        *ngIf="
                          submittedForMaterial &&
                          materialDetailForm.get('materialRecycledContent').invalid
                        "
                      >
                        The Recycled content (%)
                      </div>
                    </div>
                    <div class="topBottomCss">
                      <div
                        class="alert-error"
                        *ngIf="submittedForMaterial &&  (projectPackMaterialForm.get('materialDetailForm')?.get('materialRecycledContent')?.errors?.['min'] ||projectPackMaterialForm.get('materialDetailForm')?.get('materialRecycledContent')?.errors?.['max'])"
                      >
                        Recycled content (%) must be in between 0 to 100
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </ng-container>
    </div>
  </ng-container>

  <ng-template #popContentOne>
    <div class="d-flex justify-content-end pb-3">
      <button type="button" class="closePopover" aria-label="Close" (click)="closeAllSteps(1)">
        <img src="./assets/icons/pop-up-cross.svg" width="12" height="13" />
      </button>
    </div>
    <p class="modal-tour-text">
      Add a custom material here using a variation of material composites.
    </p>
    <div class="d-flex justify-content-between">
      <div class="step-counter d-flex align-items-center">1/5</div>
      <button class="modal-tour-btn" (click)="closePopup('one')">NEXT</button>
    </div>
  </ng-template>

  <ng-template #popContentTwo>
    <div class="d-flex justify-content-end pb-3">
      <button type="button" class="closePopover" aria-label="Close" (click)="closeAllSteps(2)">
        <img src="./assets/icons/pop-up-cross.svg" width="12" height="13" />
      </button>
    </div>
    <p class="modal-tour-text">
      Global recycled content rates are displayed here by default. You can override this.
    </p>
    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center">
        <div class="step-counter d-flex align-items-center">2/5</div>
      </div>
      <div>
        <button class="modal-tour-prev-btn" (click)="goBack('two')">PREV</button>
        <button class="modal-tour-btn" (click)="closePopup('two')">NEXT</button>
      </div>
    </div>
  </ng-template>

  <ng-template #popContentThree>
    <div class="d-flex justify-content-end pb-3">
      <button type="button" class="closePopover" aria-label="Close" (click)="closeAllSteps(3)">
        <img src="./assets/icons/pop-up-cross.svg" width="12" height="13" />
      </button>
    </div>
    <p class="modal-tour-text">Select component-specific end of life pathway.</p>
    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center">
        <div class="step-counter d-flex align-items-center">3/5</div>
      </div>
      <div>
        <button class="modal-tour-prev-btn" (click)="goBack('three')">PREV</button>
        <button class="modal-tour-btn" (click)="closePopup('three')">NEXT</button>
      </div>
    </div>
  </ng-template>

  <ng-template #popContentFour>
    <div class="d-flex justify-content-end pb-3">
      <button type="button" class="closePopover" aria-label="Close" (click)="closeAllSteps(4)">
        <img src="./assets/icons/pop-up-cross.svg" width="12" height="13" />
      </button>
    </div>
    <p class="modal-tour-text">
      Select transportation of component to the converter. We have added in 'Show only ports'
      functionality for shipping distances.
    </p>
    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center">
        <div class="step-counter d-flex align-items-center">4/5</div>
      </div>
      <div>
        <button class="modal-tour-prev-btn" (click)="goBack('four')">PREV</button>
        <button class="modal-tour-btn" (click)="closePopup('four')">NEXT</button>
      </div>
    </div>
  </ng-template>

  <ng-template #popContentFive>
    <div class="d-flex justify-content-end pb-3">
      <button type="button" class="closePopover" aria-label="Close" (click)="closeAllSteps(5)">
        <img src="./assets/icons/pop-up-cross.svg" width="12" height="13" />
      </button>
    </div>
    <p class="modal-tour-text">Assign the conversion process to components here.</p>
    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center">
        <div class="step-counter d-flex align-items-center">5/5</div>
      </div>
      <div>
        <button class="modal-tour-prev-btn" (click)="goBack('five')">PREV</button>
        <button class="modal-tour-btn" (click)="closePopup('five')">DONE</button>
      </div>
    </div>
  </ng-template>
</div>
